import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const LocaleFormat = {
  en: {
    format: 'MM/DD,YYYY, HH:mm:ss',
  },
  zh: {
    format: 'YYYY-MM-DD HH:mm:ss',
  },
};

export const dateLocaleFormat = (date, locale = 'en') => {
  const format = LocaleFormat[locale]?.format;

  if (!format) {
    return date;
  }

  return dayjs(date).format(format);
};

export const utcDateFormat = (date, format) => {
  return dayjs.utc(date).format(format);
};
